import type { SkeletonContainerElement } from "shared/atoms/SkeletonLayout";
import { SkeletonLayout } from "shared/atoms/SkeletonLayout";

export const TemplateSelectionSkeleton: React.FC = () => {
  return (
    <SkeletonLayout
      layout={{
        type: "column",
        spacing: 6,
        children: [
          {
            type: "column",
            spacing: 2.5,
            children: [
              { type: "skeleton", variant: "rounded", height: 24, width: 200 },
              { type: "skeleton", variant: "rounded", height: 16, width: "100%", sx: { maxWidth: 400 } },
              {
                type: "column",
                alignItems: "center",
                spacing: 1.5,
                children: [
                  { type: "skeleton", variant: "circular", width: 48, height: 48 },
                  { type: "skeleton", variant: "rounded", height: 16, width: 120 },
                ],
              },
            ],
          },
          {
            type: "column",
            spacing: 2.5,
            children: [
              { type: "skeleton", variant: "rounded", height: 24, width: 200 },
              { type: "skeleton", variant: "rounded", height: 16, width: "100%", sx: { maxWidth: 400 } },
              { type: "skeleton", variant: "rounded", height: 36, width: 250 },
              {
                type: "row",
                sx: { flexWrap: "wrap", gap: "16px" },
                children: [...Array(6)].map(
                  (): SkeletonContainerElement => ({
                    type: "column",
                    alignItems: "center",
                    spacing: 1.5,
                    width: "calc(50% - 8px)",
                    children: [
                      { type: "skeleton", variant: "rounded", width: 64, height: 64 },
                      { type: "skeleton", variant: "rounded", height: 16, width: 120 },
                    ],
                  })
                ),
              },
            ],
          },
        ],
      }}
    />
  );
};
